// Generated by scripts/generate-svg-components.mjs. Do not edit manually.
export const FDK_ILLUSTRATION_NAMES = [
  'connecting',
  'empty',
  'identifying',
  'loading-1',
  'loading-2',
  'loading-3',
  'location',
  'sign-in',
  'success',
  'warning',
  'welcome-1',
  'welcome-2',
  'welcome-3',
  'welcome-animated',
] as const;

export type FdkIllustrationName = typeof FDK_ILLUSTRATION_NAMES[number];

export const FDK_ILLUSTRATION_DEFAULT_WIDTHS: Record<
  FdkIllustrationName,
  number
> = {
  'connecting': 118,
  'empty': 118,
  'identifying': 118,
  'loading-1': 66,
  'loading-2': 66,
  'loading-3': 66,
  'location': 118,
  'sign-in': 118,
  'success': 118,
  'warning': 118,
  'welcome-1': 232,
  'welcome-2': 232,
  'welcome-3': 232,
  'welcome-animated': 232,
};
